import React from 'react';

function ClientSlide(props) {
    const imageAlt = props.image?.alt || (props.image?.name ? `${props.image.name} logo` : 'Client logo');

    return (
        <div className="client-image">
            <img src={props.image.src} alt={imageAlt} loading="lazy" decoding="async" />
        </div>
    );
}

export default ClientSlide;
